import { every, match } from 'components/Shared/Form';

const isValidZipcodeFormatNorway = match(/\d{4}/);

export const ZIP_CODE_LENGTH = 4;

export const isValidZipcode = every(isValidZipcodeFormatNorway);

export { getFormattedZipCode } from '../BGH/validation';
